<template>
  <b-row v-if="!dataLoad">
    <b-col
      cols="12"
      md="12"
    >
      <SelectActivities
        :show-select-activities="true"
        @handleActivities="handleActivities"
        @handleActivitiesProduct="handleActivitiesProduct"
      />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <SelectSearchOnly
        :show-select-search="true"
        @handleSearchOnly="handleSearch"
      />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <SelectStatus
        :show-select-status="true"
        @handleStatus="handleStatus"
      />
    </b-col>
    <b-col
      cols="12"
      md="4"
      class="d-flex justify-content-end"
    >
      <SearchBtnAction
        :view-search-btn="true"
        :data-load="dataLoad"
        :get-all-data="getAllData"
      />
    </b-col>
  </b-row>
</template>

<script>
import SelectActivities from './fixed-filter/SelectActivities.vue'
import SelectStatus from './fixed-filter/SelectStatus.vue'
import SearchBtnAction from '../actions/SearchBtnAction.vue'
import SelectSearchOnly from './fixed-filter/SelectSearchOnly.vue'

export default {
  components: {
    SelectStatus,
    SelectActivities,
    SearchBtnAction,
    SelectSearchOnly,
  },
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
  data() {
    return {
      office_id: '',
      office_role: '',
    }
  },
  methods: {
    handleStatus(status) {
      this.$emit('handleStatus', status)
    },
    handleActivities(name) {
      const ids = name.map(item => item.value).join(',')
      this.$emit('handleActivities', ids)
    },
    handleActivitiesProduct(name) {
      const ids = name.map(item => item.value).join(',')
      this.$emit('handleActivitiesProduct', ids)
    },
    handleSearch(name) {
      this.$emit('handleSearchOnly', name)
    },
  },
}
</script>
